import { SSA_ROLE_PARAMETER } from '../auth/config/auth-config-helpers';
import { hasUserRole, SSA_USER } from './user-roles';

const LEGACY_SAVE_PATH = '/web/';
const LEGACY_SAVE_SSA_PATH = '/VisSsa/';
const LEGACY_SAVE_SSA_SIMULATOR_PATH = '/VisSsa2/';

export const getBasePaths = (userRoles: string[]): string => {
  let ssaRole = localStorage.getItem(SSA_ROLE_PARAMETER);
  let isSSAUser = hasUserRole(userRoles, SSA_USER);

  // if SSA role exists we know that we aren't using ISAM Simulator and should go to the VisSSA Legacy SAVE Application to make requests.
  if (isSSAUser && ssaRole) {
    return LEGACY_SAVE_SSA_PATH;
  } else if (isSSAUser) {
    return LEGACY_SAVE_SSA_SIMULATOR_PATH;
  } else {
    return LEGACY_SAVE_PATH;
  }
};
